var _excluded = ["placeholder", "value", "onSelect", "options", "addButton", "isReadOnly", "footerAction", "isLoading", "optionsToDisplayOnSelect", "isInvalid", "popoverProps", "tooltipProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useState } from 'react';
import { Group, SelectableDropdownMenu } from '../../../containers';
import { Icon } from '../../../foundations/Icon';
import { isBrandSymbol } from '../../../theme/icons/utils';
import { forwardRef } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { NakedButton } from '../../action';
import { BrandSymbol, Text } from '../../dataDisplay';
import { Image } from '../../media';
import { _IconIndicator as IconIndicator } from '../_IconIndicator';
import { _TableCell as TableCell } from '../_TableCell';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/**
 * @private Please use `Table.SelectCell` from `@melio/penny`.
 */
export var _TableSelectCell = forwardRef((_ref, ref) => {
  var _selectedOptionToDisp, _props$dataTestid, _options$find;

  var {
    placeholder,
    value,
    onSelect,
    options,
    addButton,
    isReadOnly,
    footerAction,
    isLoading,
    optionsToDisplayOnSelect,
    isInvalid,
    popoverProps,
    tooltipProps
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useMultiStyleConfig('TableSelectCell', {});
  var selectedOptionToDisplay = (optionsToDisplayOnSelect === null || optionsToDisplayOnSelect === void 0 ? void 0 : optionsToDisplayOnSelect.find(option => option.value === value)) || (options === null || options === void 0 ? void 0 : options.find(option => option.value === value));
  var [isMenuOpen, setIsMenuOpen] = useState(false);
  var [isHovered, setIsHovered] = useState(false);

  var handleSelect = item => {
    if (!value || item.value !== value) {
      onSelect(item.value);
    }

    setIsMenuOpen(false);
  };

  var iconOrImage = selectedOptionToDisplay !== null && selectedOptionToDisplay !== void 0 && selectedOptionToDisplay.icon ? isBrandSymbol(selectedOptionToDisplay.icon) ? /*#__PURE__*/_jsx(BrandSymbol, {
    type: selectedOptionToDisplay.icon,
    size: "medium"
  }) : /*#__PURE__*/_jsx(Icon, {
    size: "small",
    type: selectedOptionToDisplay === null || selectedOptionToDisplay === void 0 ? void 0 : selectedOptionToDisplay.icon,
    color: "default"
  }) : (selectedOptionToDisplay === null || selectedOptionToDisplay === void 0 ? void 0 : selectedOptionToDisplay.image) && /*#__PURE__*/_jsx(Image, {
    src: selectedOptionToDisplay.image.src,
    alt: selectedOptionToDisplay.image.alt
  });
  var optionLabel = (_selectedOptionToDisp = selectedOptionToDisplay === null || selectedOptionToDisplay === void 0 ? void 0 : selectedOptionToDisplay.label) !== null && _selectedOptionToDisp !== void 0 ? _selectedOptionToDisp : placeholder;
  var dataTestIdPrefix = (_props$dataTestid = props['data-testid']) !== null && _props$dataTestid !== void 0 ? _props$dataTestid : 'table-select-cell';
  var dropdownSelectableTestId = "".concat(dataTestIdPrefix, "-dropdown-selectable");

  var warningIcon = /*#__PURE__*/_jsx(IconIndicator, _objectSpread(_objectSpread({
    variant: "warning"
  }, popoverProps ? {
    popover: popoverProps
  } : tooltipProps ? {
    tooltip: tooltipProps
  } : {}), {}, {
    "data-testid": "".concat(dataTestIdPrefix, "-warning-icon")
  }));

  var caretIcon = /*#__PURE__*/_jsx(Icon, {
    type: isMenuOpen ? 'caret-up' : 'caret-down',
    size: "small",
    color: "default",
    "aria-hidden": true
  });

  var showWarningIcon = !isLoading && isInvalid;
  var triggerRight = !isLoading && !isReadOnly && caretIcon;
  var noOptionsRight = showWarningIcon ? warningIcon : undefined;

  var trigger = /*#__PURE__*/_jsx(TableCell, _objectSpread(_objectSpread({
    "data-component": "_TableSelectCell",
    "data-testid": "table-select-cell"
  }, props), {}, {
    children: /*#__PURE__*/_jsxs(Group, {
      width: "full",
      alignItems: "center",
      spacing: "none",
      children: [!!iconOrImage && /*#__PURE__*/_jsx(Box, {
        __css: styles['leftIcon'],
        children: iconOrImage
      }), optionLabel && /*#__PURE__*/_jsx(Text, {
        textStyle: "inline",
        color: value ? 'inherit' : 'neutral.darker',
        shouldSupportEllipsis: true,
        children: optionLabel
      }), !!showWarningIcon && /*#__PURE__*/_jsx(Box, {
        __css: styles['warningIcon'],
        children: warningIcon
      }), !!triggerRight && /*#__PURE__*/_jsx(Box, {
        __css: styles['rightIcon'],
        children: triggerRight
      })]
    })
  }));

  var optionsWithTestIds = options === null || options === void 0 ? void 0 : options.map((option, index) => _objectSpread(_objectSpread({}, option), {}, {
    index,
    dataTestId: "table-select-cell-dropdown-item-".concat(option.value)
  }));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: options !== null && options !== void 0 && options.length || selectedOptionToDisplay ? /*#__PURE__*/_jsx(SelectableDropdownMenu, {
      selectedItemValue: options === null || options === void 0 ? void 0 : (_options$find = options.find(option => option.value === value)) === null || _options$find === void 0 ? void 0 : _options$find.value,
      trigger: trigger,
      items: optionsWithTestIds,
      onOpenChange: setIsMenuOpen,
      onSelect: handleSelect,
      isOpen: isMenuOpen,
      isReadOnly: isReadOnly,
      ref: ref,
      footer: footerAction !== null && footerAction !== void 0 && footerAction.label ? footerAction : undefined,
      dropdownTestId: dropdownSelectableTestId,
      size: "small"
    }) : /*#__PURE__*/_jsx(TableCell, _objectSpread(_objectSpread({
      "data-component": "_TableSelectCell",
      onClick: addButton === null || addButton === void 0 ? void 0 : addButton.onClick,
      ref: ref,
      onMouseEnter: () => setIsHovered(true),
      onMouseLeave: () => setIsHovered(false)
    }, props), {}, {
      children: /*#__PURE__*/_jsxs(Group, {
        alignItems: "center",
        justifyContent: "flex-start",
        spacing: "xxs",
        width: "full",
        children: [/*#__PURE__*/_jsx(NakedButton, {
          variant: "secondary",
          "data-hover": isHovered || undefined,
          onClick: addButton === null || addButton === void 0 ? void 0 : addButton.onClick,
          "data-testid": addButton === null || addButton === void 0 ? void 0 : addButton.dataTestId,
          label: (addButton === null || addButton === void 0 ? void 0 : addButton.text) || 'Add'
        }), noOptionsRight]
      })
    }))
  });
});
_TableSelectCell.displayName = '_TableSelectCell';
//# sourceMappingURL=_TableSelectCell.js.map